
// Function to get URL parameters
function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const year = params.get('year');
  const make = params.get('make');
  const model = params.get('model');
  const variant = params.get('variant');

  return { year, make, model, variant };
}

// Function to update the title
function updateTitle() {
  const { year, make, model } = getUrlParams();
  let title = "Search results for:";

  if (year) {
    title += ` ${year}`;
  }
  if (make) {
    title += ` ${make.toUpperCase()}`;
  }
  if (model) {
    title += ` ${model.toUpperCase()}`;
  }

  document.getElementById('search-results-title').innerText = title;
}

// Function to get URL parameters and construct a new URL
function constructFetchUrl() {
  // Get the current URL parameters
  const params = new URLSearchParams(window.location.search);
  
  // Construct the new URL
  const baseUrl = '/apps/gadget/parts';
  const fetchUrl = `${baseUrl}?${params.toString()}`;

  return fetchUrl;
}

document.addEventListener("DOMContentLoaded", function() {
  // Call the function to update the title on page load
  updateTitle();

  // Fetch data
  let url = constructFetchUrl()
  fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    return response.json(); 
  })
  .then(resData => {
    data = resData;
    console.log('result data: ', resData); 
    displayItems(resData)
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });  
});

 

function displayItems(data){
  const wrapperNode = document.querySelector('#product-grid');

  if (data.products.length > 0){
    data.products.forEach(item => {
      // Create a new list element
      let li = document.createElement('li');
      li.className = 'grid-item';
      
      // Create the product card structure
      li.innerHTML = `
        <product-card class="card card-product card-product-no-rating color-background-2">
          <figure class="card-media">
            <a href="/products/${item.handle}" class="js-product-link cp">
              <div class="aspect-ratio" style="--ratio-percent: 100%;">
                <img src="${item.images[0]}" loading="lazy" class="card-media-image" alt="${item.title}">
              </div>
            </a>
          </figure>
          <div class="card-info-wrap">
            <div class="card-info">
              <div class="card-eyebrow">
                <a href="/collections/vendors?q=${encodeURIComponent(item.vendor)}" title="${item.vendor}">${item.vendor}</a>
              </div>
              <h3 class="card-heading typography-headings">
                <a href="/products/${item.handle}" class="js-product-link">${item.title}</a>
              </h3>
              <div class="badge-sku-wrap cp">
                <span class="product-info-meta-item-code sku">${item.variants[0].sku}</span>
              </div>
            </div>
            <div class="card-footer">
              <div class="card-floating-footer">
              <div class="product-actions card-product-actions">
                <div class="product-actions-add-to-cart">
                  <a href="/products/${item.handle}" class="button button-secondary button-add-to-cart button-outline"><span>View Product</span>
                    <div class="button-overlay-spinner hidden">
                      <span class="spinner-xs"></span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            </div>
          </div>
        </product-card>
      `;
  
      // Append the new list item to the product grid
      wrapperNode.appendChild(li);
      
      // Hide loading spinner
      document.querySelector('#product-grid .spinner-lg').classList.add('hidden')
    });
  }else {
    // No result
    let noResultMsg = document.createElement('p');
    noResultMsg.className = 'no-result-msg';
    noResultMsg.innerHTML = `No result`
    wrapperNode.appendChild(noResultMsg);
  }
  
}